import axiosAuth from '@/utils/axios';
import { URL_API } from '@/config/api';

export async function getUserPlataformsAccounts() {

  const url = `${URL_API}/user_plataforms_accounts`;
  
  const {data} = await axiosAuth.get(url);
  return data;
}